import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Remove tokens from sessionStorage
    window.sessionStorage.removeItem("jwtToken");
    window.sessionStorage.removeItem("refreshToken");

    // Redirect to the login page or homepage
    navigate("/"); // Change to your login route
  }, [navigate]);

  return (
    <div className="container text-center mt-5">
      <h4>Logging you out...</h4>
    </div>
  );
};

export default Logout;
